import * as tslib_1 from "tslib";
import { OnInit, NgZone, ElementRef, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { timer } from 'rxjs';
import { licToAuthorityShortDescription } from '../detail/detail.component';
export class DownloadTooltipComponent {
    constructor(zone, elRef, platformId, request, serverConfigService, globalComponentService) {
        this.zone = zone;
        this.elRef = elRef;
        this.platformId = platformId;
        this.request = request;
        this.serverConfigService = serverConfigService;
        this.globalComponentService = globalComponentService;
        /** 是否為開啟中 */
        this.isOpened = false;
        /** 是否為開啟中 */
        this.isAnimating = false;
        this.opened = new EventEmitter();
        this.closed = new EventEmitter();
    }
    get hostEl() { return this.elRef ? this.elRef.nativeElement : null; }
    ngOnInit() { }
    ngOnChanges(changes) {
        if (this.data && this.fetchIndexCode && this.sharePageUrl && this.authorityImg && this.authorityLink && this.authorityText) {
            const sb = [];
            switch (this.fetchIndexCode) {
                case 'Culture_Event':
                case 'Culture_Object':
                case 'Culture_Media':
                case 'Culture_Route':
                case 'Culture_Invisible':
                    {
                        sb.push(this.data.title);
                        if (this.data['contributor']) {
                            sb.push(`撰寫者：${this.data['contributor']}`);
                        }
                        if (this.data.contentLic) {
                            sb.push(`描述文字授權：${licToAuthorityShortDescription(this.data.contentLic)}`);
                        }
                        if (this.data['createDept']) {
                            sb.push(`建檔單位：${this.data['createDept']}`);
                        }
                        this.downloadRightsCitation = `${sb.join(' / ')} @ 國家文化記憶庫 ${this.sharePageUrl}`;
                    }
                    break;
                case 'Culture_People':
                case 'Culture_Organization':
                    {
                        sb.push(this.data.title);
                        if (this.data['creator']) {
                            sb.push(`撰寫者：${this.data['creator']}`);
                        }
                        if (this.data.contentLic) {
                            sb.push(`描述文字授權：${licToAuthorityShortDescription(this.data.contentLic)}`);
                        }
                        if (this.data['createDept']) {
                            sb.push(`建檔單位：${this.data['createDept']}`);
                        }
                        this.downloadRightsCitation = `${sb.join(' / ')} @ 國家文化記憶庫 ${this.sharePageUrl}`;
                    }
                    break;
                case 'Culture_Place':
                    {
                        sb.push(this.data.title);
                        if (this.data['writer']) {
                            sb.push(`撰寫者：${this.data['writer']}`);
                        }
                        if (this.data.contentLic) {
                            sb.push(`描述文字授權：${licToAuthorityShortDescription(this.data.contentLic)}`);
                        }
                        if (this.data['createDept']) {
                            sb.push(`建檔單位：${this.data['createDept']}`);
                        }
                        this.downloadRightsCitation = `${sb.join(' / ')} @ 國家文化記憶庫 ${this.sharePageUrl}`;
                    }
                    break;
                default:
                    this.downloadRightsCitation = `${this.data.title ? this.data.title + ' / ' : ''}${this.data.sourceName ? '授權人：' + this.data.sourceName + ' / ' : ''}${this.authorityText} @ 國家文化記憶庫 ${this.sharePageUrl}。`;
                    break;
            }
        }
    }
    open() {
        this.isAnimating = true;
        this.opened.emit();
        timer(250).subscribe(t => {
            this.zone.run(() => {
                this.isAnimating = false;
                this.isOpened = true;
            });
        });
    }
    close() {
        this.isAnimating = true;
        this.closed.emit();
        timer(250).subscribe(t => {
            this.zone.run(() => {
                this.isAnimating = false;
                this.isOpened = false;
            });
        });
    }
    toggle() {
        if (this.isAnimating) {
            return;
        }
        if (this.isOpened) {
            this.close();
        }
        else {
            this.open();
        }
    }
    /** 複製 input 元素內容到剪貼簿 - 支援 iOS */
    copyToClipBoard(target) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const inputEl = target;
            if (!inputEl || inputEl.tagName !== 'TEXTAREA') {
                console.error('copyToClipBoard，目標不是 textArea 元素');
                return false;
            }
            try {
                const text = inputEl.value;
                // 優先使用現代 Clipboard API
                if (navigator.clipboard && window.isSecureContext) {
                    // 確保 input 可以被選取
                    inputEl.readOnly = false;
                    inputEl.disabled = false;
                    // 聚焦並選取所有內容
                    inputEl.focus();
                    inputEl.select();
                    yield navigator.clipboard.writeText(text);
                    // 恢復原始狀態
                    inputEl.readOnly = true;
                    inputEl.blur(); // 移除焦點
                    return true;
                }
                // Fallback 到選取 + execCommand 方式
                return this.selectAndCopy(inputEl);
            }
            catch (error) {
                console.error('Clipboard API 複製失敗，嘗試 fallback 方式', error);
                // 如果 Clipboard API 失敗，嘗試 fallback 方式
                return this.selectAndCopy(inputEl);
            }
        });
    }
    /** 選取 input 內容並複製 */
    selectAndCopy(inputEl) {
        try {
            // 確保 input 可以被選取
            inputEl.readOnly = false;
            inputEl.disabled = false;
            // 聚焦並選取所有內容
            inputEl.focus();
            inputEl.select();
            // iOS 需要額外設置選取範圍
            if (this.isIOSDevice()) {
                inputEl.setSelectionRange(0, inputEl.value.length);
            }
            // 執行複製命令
            const successful = document.execCommand('copy');
            // 恢復原始狀態
            inputEl.readOnly = true;
            inputEl.blur(); // 移除焦點
            return successful;
        }
        catch (error) {
            console.error('selectAndCopy 選取複製失敗:', error);
            return false;
        }
    }
    /** 檢測是否為 iOS 設備 */
    isIOSDevice() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }
    /** 顯示複製結果的輔助方法 */
    handleCopyWithFeedback(target) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const success = yield this.copyToClipBoard(target);
            if (!success) {
                console.log('複製失敗，請手動選取複製');
            }
            else if (this.isIOSDevice()) {
                window.alert('已複製到剪貼簿');
            }
        });
    }
}
